<template>
  <div class="app-card">
    <div class="card-content">
      <img :src="thumbnail" :alt="name" class="thumbnail" />
      <div class="text-content">
        <h3>{{ name }}</h3>
        <p>{{ description }}</p>
        <span class="status">{{ status }}</span>
        <router-link
            v-if="name === 'Construction Code AI Assistant'"
            to="/construction-code-ai-assistant"
            class="learn-more">
          Learn More →
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
.app-card {
  text-align: left;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  background-color: #fff;
  margin-bottom: 24px;
}

.card-content {
  display: flex;
  gap: 16px;
  align-items: center; /* Changed from flex-start to center */
}

.thumbnail {
  width: 180px;
  height: 180px; /* Added fixed height for consistency */
  object-fit: cover; /* Ensures image fills space nicely */
  flex-shrink: 0;
  border-radius: 8px;
}

.text-content {
  flex: 1;
  display: flex; /* Added to create vertical flex container */
  flex-direction: column; /* Stack children vertically */
  justify-content: center; /* Center content vertically */
  min-height: 200px; /* Match thumbnail height */
}

.learn-more {
  display: block;
  margin-top: 10px;
  color: blue;
  text-decoration: none;
  font-weight: bold;
}

.status {
  display: inline-block;
  margin-top: 8px;
  font-size: 0.9em;
  color: #666;
}

h3 {
  margin-top: 0;
  margin-bottom: 8px; /* Added for better spacing */
}

p {
  margin: 0; /* Reset margins for better control */
  margin-bottom: 8px;
}
</style>

<script>
export default {
  props: {
    name: String,
    thumbnail: String,
    description: String,
    status: String,
  },
};
</script>